import axiosInstance from './axiosInstance';

export const getEmailCompliance = (companyId) =>
	axiosInstance.get(`/email-compliance/${companyId}`);

export const submitEmailVetting = (companyId, data) =>
	axiosInstance.post(`/email-compliance/${companyId}/submit`, data);

export const listPendingEmailVetting = () =>
	axiosInstance.get('/email-compliance/admin/pending');

export const getEmailComplianceAdminStats = () =>
	axiosInstance.get('/email-compliance/admin/stats');

export const listEmailComplianceByTab = (tab) =>
	axiosInstance.get('/email-compliance/admin/list', { params: { tab } });

export const reviewEmailVetting = (companyId, data) =>
	axiosInstance.post(`/email-compliance/${companyId}/review`, data);

export const provisionSubuserForCompany = (companyId) =>
	axiosInstance.post(`/email-compliance/admin/${companyId}/provision-subuser`);

export const getEmailReputation = (companyId) =>
	axiosInstance.get(`/email-compliance/${companyId}/reputation`);
